import revive_payload_client_4sVQNw7RlN from "/var/www/biopas-programa-paciente-form/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/biopas-programa-paciente-form/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/biopas-programa-paciente-form/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/biopas-programa-paciente-form/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/biopas-programa-paciente-form/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/biopas-programa-paciente-form/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/var/www/biopas-programa-paciente-form/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/biopas-programa-paciente-form/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import vuetify_7h9QAQEssH from "/var/www/biopas-programa-paciente-form/plugins/vuetify.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  vuetify_7h9QAQEssH
]